const error404 = {
    title: 'Erreur 404',
    header: 'Introuvable',
    message: "Vous venez de prendre un chemin qui n'existe pas.",
    link: "Retour à la page d'accueil",
}

export default error404
